import { render } from "./PromocionesCategorias.vue?vue&type=template&id=3ca10b54&scoped=true"
import script from "./PromocionesCategorias.vue?vue&type=script&lang=js"
export * from "./PromocionesCategorias.vue?vue&type=script&lang=js"

import "./PromocionesCategorias.vue?vue&type=style&index=0&id=3ca10b54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca10b54"]])

export default __exports__